<div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" >    
    <mat-card style="min-width: 400px; transition: none !important; box-shadow: none !important;">
        <mat-card-title>
            <div style="margin: 20px" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                <span>Cancelar Turno</span>
            </div>
        </mat-card-title>
        <mat-card-content>
            <div fxLayout="column" fxLayoutWrap="wrap">
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" style="margin: 10px 0 0 0;">
                    <mat-form-field fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                        <textarea matInput [placeholder]="'Motivo'" rows="3" [(ngModel)]="appointment.cancelNote"></textarea>
                    </mat-form-field>
                </div>
                <div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                    <mat-slide-toggle [(ngModel)]="appointment.reassign" (change)="reassignToggle($event)">
                        Reasignar nuevo turno
                    </mat-slide-toggle>
                </div>
                
                <div style="height: 150px;">
                    <div *ngIf="appointment.reassign">
                        <h4>Nuevo Turno</h4>
                        <p>Fecha: <strong>{{appointment.dateFrom | date:"dd/MM/yyyy"}}</strong></p>
                        <p>
                            Desde <strong>{{appointment.dateFrom | date:"HH:mm"}}</strong> 
                            Hasta <strong>{{appointment.dateTo | date:"HH:mm"}}</strong>
                        </p>
                    </div>
                </div>
            </div>
        </mat-card-content>
        <mat-card-footer>
            <div style="margin: 20px; text-align: right;" fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100">
                <button (click)="closeDialog()" mat-button color="primary">Cancelar</button>
                <button (click)="doAction()" mat-raised-button color="warn">Aceptar</button>
            </div>
        </mat-card-footer>
    </mat-card>
</div>
<div fxFlex.gt-sm="100" fxFlex.gt-xs="100" fxFlex="100" [ngClass] = "{ 'clssHide': !appointment.reassign }" >
    <full-calendar #calendar [plugins]="calendarPlugins" defaultView="dayGridMonth"
        (eventClick)="eventClicked($event)">
    </full-calendar>
</div>